import React from "react";
import { ActiveCard } from "./partials/ActiveCard";
import ButtonCardType from "../partials/ButtonCardType";

const PrimaryCardBG = ({ activeCard, type }) => {
  return (
    <>
      <div
        className={`primary-card max-h-[420px] max-md:max-h-[520px] space-y-3 py-3`}
      >
        <ActiveCard />
        <div className="flex items-center justify-between md:space-x-8 space-x-4">
          <ButtonCardType type={type} activeCard={activeCard} />
        </div>
      </div>
    </>
  );
};

export default PrimaryCardBG;
